// AI Disclaimer Component
// ========================
// Displays a disclaimer about AI limitations

import React from 'react';

interface AIDisclaimerProps {
  variant?: 'compact' | 'full';
  className?: string;
}

const AIDisclaimer: React.FC<AIDisclaimerProps> = ({ variant = 'compact', className = '' }) => {
  if (variant === 'compact') {
    return (
      <p className={`text-xs text-gray-500 dark:text-gray-400 ${className}`}>
        Anna er et AI-værktøj og kan tage fejl. Tjek altid din studieordning og officielle eksamenskrav.
      </p>
    );
  }

  return (
    <div className={`bg-amber-50 dark:bg-amber-900/20 border border-amber-200 dark:border-amber-800 rounded-lg p-4 ${className}`}>
      <div className="flex items-start gap-3">
        <span className="text-amber-600 dark:text-amber-400 text-xl flex-shrink-0">!</span>
        <div>
          <h4 className="font-medium text-amber-800 dark:text-amber-200 mb-1">
            Vigtigt om Anna
          </h4>
          <p className="text-sm text-amber-700 dark:text-amber-300">
            Anna er en AI-studiekammerat, der hjælper dig med at forstå stoffet - men hun kan tage fejl.
            Verificer altid vigtige oplysninger med din studieordning, pensumlister og officielle eksamenskrav
            fra din uddannelsesinstitution.
          </p>
        </div>
      </div>
    </div>
  );
};

export default AIDisclaimer;
